import AppTable from '@/components/AppTable';
import { formatNumber } from '@/utils/formatters';
import { Table } from 'antd';
import React from 'react';

const columns = [
  {
    title: 'Package',
    dataIndex: 'package_code',
    key: 'package_code',
    fixed: 'left',
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    render: (value) => (value > 0 ? formatNumber(value) : 0),
  },
  {
    title: 'Revenue (Kyat)',
    children: [
      {
        title: 'SMS',
        dataIndex: 'sms',
        key: 'sms',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'USSD',
        dataIndex: 'ussd',
        key: 'ussd',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'WEB/WAP',
        dataIndex: 'web_wap',
        key: 'web_wap',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Total Register',
        dataIndex: 'total_register',
        key: 'total_register',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Total Renew',
        dataIndex: 'total_renew',
        key: 'total_renew',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Total Revenue',
        dataIndex: 'total_revenue',
        key: 'total_revenue',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
    ],
  },
];

function OverviewTable({ dataSource, totals, loading }) {
  return (
    <div className="mt-4 space-y-4 w-full">
      <AppTable
        tableTitle={<p className="font-semibold">Overview statistic table</p>}
        columns={columns}
        dataSource={dataSource}
        hasPagination={false}
        loading={loading}
        disableColumnVisibility={true}
        summary={() => {
          if (!totals) return null;

          const values = [
            'Total',
            totals.quantity,
            totals.sms,
            totals.ussd,
            totals.web_wap,
            totals.total_register,
            totals.total_renew,
            totals.total_revenue,
          ];

          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                {values.map((value, index) => (
                  <Table.Summary.Cell
                    key={index}
                    index={index}
                    align="center"
                    className="font-medium"
                  >
                    {typeof value === 'number' ? formatNumber(value) : value}
                  </Table.Summary.Cell>
                ))}
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
    </div>
  );
}

export default OverviewTable;
